import { render } from "./CadastroEndereco.vue?vue&type=template&id=12eb0073&scoped=true&lang=html"
import script from "./CadastroEndereco.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroEndereco.vue?vue&type=script&setup=true&lang=js"

import "./CadastroEndereco.vue?vue&type=style&index=0&id=12eb0073&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12eb0073"]])

export default __exports__